/** Destinations the landing page links to. Change here, not in components. */
export const APP_URL = 'https://app.genie.art'
export const LOGIN_URL = 'https://app.genie.art/login'
export const X_URL = 'https://x.com/genieart_inc'

/** In-page anchors: the download section and the compatibility check inside it. */
export const DOWNLOAD_ANCHOR = '#download'
export const COMPAT_ANCHOR = '#compat'

/**
 * The macOS build. Releases are self-hosted at genie.art/download (the desktop
 * repo is private, so GitHub Releases can't serve them). /download 302s to the
 * current DMG; latest.json describes it. `scripts/release.sh` in the desktop
 * repo publishes both. MAC_BUILD is the fallback shown until latest.json loads
 * (see hooks/useLatestBuild).
 */
export const MAC_DOWNLOAD_URL = 'https://genie.art/download'
export const LATEST_BUILD_URL = 'https://genie.art/download/latest.json'
export const MAC_BUILD = {
  file: 'Genie-0.1.5-arm64.dmg',
  size: '351 MB',
  requirements: 'Apple Silicon Mac',
} as const

export const WAITLIST_PATH = '/waitlist'
